export default __webpack_public_path__ + "static/media/vertical1.cba4ce2f.JPG";